import { render, staticRenderFns } from "./assistir-aula.vue?vue&type=template&id=3a7a2ba1&"
import script from "./assistir-aula.vue?vue&type=script&lang=js&"
export * from "./assistir-aula.vue?vue&type=script&lang=js&"
import style0 from "./assistir-aula.vue?vue&type=style&index=0&id=3a7a2ba1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports